import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

// TODO pas du tout le bon endroit pour ce composant, à déplacer
@Component({
    selector: 'app-feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss'],
    imports: [
        CommonModule,
        MatDialogModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        TranslateModule
    ]
})
export class FeedbackComponent<T> implements OnInit {
    public btnTitle: string;
    public innerHtmlContent: string;
    public title: string;
    public content: string;

    constructor(@Inject(MAT_DIALOG_DATA) public data: {
                    btnTitle?: string;
                    title: string;
                    content: string;
                    innerHtmlContent: string;
                    callback: () => T;
                },
                public dialogRef: MatDialogRef<FeedbackComponent<T>>) { }

    ngOnInit(): void {
        this.btnTitle = this.data.btnTitle;
        this.title = this.data.title;
        this.content = this.data.content;
        this.innerHtmlContent = this.data.innerHtmlContent;
    }

    public close(): void {
       this.dialogRef.close();
    }

}